import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';

import { RubricTreePropType } from 'propTypes/common';
import { useIsMobileWithBreakpoint } from 'hooks/useIsMobileWithBreakpoint';
import MobileEventControls from './components/MobileEventControls';
import DesktopEventControls from './components/DesktopEventControls';

const PersonsFilterControls = ({
	urlParams,
	rubricsTree,
	handleFilterChange
}) => {
	const isMobile = useIsMobileWithBreakpoint('tabletSmall');

	const rubricOptions = rubricsTree.children.map(({ name, title }) => ({
		name,
		title
	}));

	const filters = {
		..._(urlParams).pick('sort', 'query'),
		rubric: {
			selected: !_.isEmpty(urlParams?.rubric) ? urlParams?.rubric[0] : '',
			options: rubricOptions
		}
	};

	return (
		<>
			{isMobile ? (
				<MobileEventControls
					onFilterChange={handleFilterChange}
					filters={filters}
				/>
			) : (
				<DesktopEventControls
					onFilterChange={handleFilterChange}
					filters={filters}
				/>
			)}
		</>
	);
};

PersonsFilterControls.propTypes = {
	urlParams: PropTypes.object.isRequired,
	rubricsTree: RubricTreePropType.isRequired,
	handleFilterChange: PropTypes.func.isRequired
};

export default PersonsFilterControls;
